import React from 'react';
import {useState} from 'react';
import {useSelector} from 'react-redux';
import {useEffect} from 'react';

// react-bootstrap components
import {
  Button,
  Card,
  Row,
  Col,
} from 'react-bootstrap';
import FullCalendar from '@fullcalendar/react';
import timeGridPlugin from '@fullcalendar/timegrid';
import axios from 'components/Axios/Axios.js';
import dayGridPlugin from '@fullcalendar/daygrid';
import DNS from 'components/DNS/dns.js';

import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import {isMobile, isTablet} from 'react-device-detect';

// import ModalADDReservation from './modalADD';
// import ModalEDITReservation from './modalEDIT';
import ModalVIEWDELETEReservation from './modalVIEWDELETE';
import moment from 'moment';

/**
 * This function handle all the event and style in the reservation page.
 * @function Reservations
 * @return {HTML} the reservation's page.
 */
function Place() {
  const token = useSelector((state) => state.token);
  const currentBuilding = useSelector((state) => state.currentBuilding);
  const user = useSelector((state) => state.user);
  const animatedComponents = makeAnimated();

  const [showEventTitle, setEventTitle] = useState('');
  // const [showReserved, setReserved] = useState([{name: 'Choisir...'}]);
  const [showEventName, setEventName] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  // const [showSalle, setSalle] = useState([]);
  const [showSalleValue, setSalleValue] = useState([]);
  const [showSalleValueSelected, setSalleValueSelected] = useState([]);
  // const [showSalleSelected, setSalleSelected] = useState([]);
  const [showResPk, setResPk] = useState('');
  // const [showModal, setShowModal] = useState(false);
  {
    /* Modal for Create method */
  }
  // const [showTitle, setTitle] = useState('');
  const [showCreatedBy, setCreatedBy] = useState({entreprise: ''});
  const [showDebutDate, setDebutDate] = useState('');
  const [showDebutTime, setDebutTime] = useState('');
  const [showEndTime, setEndTime] = useState('');

  // Disposition de la Salle
  const [showStartWeekDate, setStartWeekDate] = useState(Date());
  const [showEndWeekDate, setEndWeekDate] = useState(Date());
  const calendarRef = React.createRef(FullCalendar);

  const [showModal2, setShowModal2] = useState(false);
  {
    /* Modal for View method */
  }
  const [showModal3, setShowModal3] = useState(false);
  {
    /* Modal for EDIT method */
  }
  const [LReservations, setReservations] = useState(
      {
        data: null,
        error: false,
      },
      [],
  );
  const requestOptionsAxiosGet = {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'token ' + token['tokenRedux'],
    },
  };
  // const [showTodayDate, setTodayDate] = useState('');
  // const [showMaxdayDate, setMaxdayDate] = useState('');

  // const getTodayDate = () => {
  //   let today = new Date();
  //   const dd = String(today.getDate()).padStart(2, '0');
  //   const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
  //   const yyyy = today.getFullYear();

  //   today = yyyy + '-' + mm + '-' + dd;
  //   const maxday = yyyy + 1 + '-' + mm + '-' + dd;

  //   setTodayDate(today);
  //   setMaxdayDate(maxday);
  // };

  useEffect(() => {
    const calendarApi = calendarRef.current.getApi();
    const type = moment(calendarApi.getDate());
    const start = type.startOf('week').add(1, 'days').format('YYYY-MM-DD');
    const end = type.endOf('week').add(1, 'days').format('YYYY-MM-DD');
    setStartWeekDate(start);
    setEndWeekDate(end);

    // getTodayDate();
    getSalle();
    getReservations(start, end);
  }, []);

  const cleanDataReservation = () => {
    // setShowModal(false);
    setShowModal2(false);
    setShowModal3(false);
    console.log(showModal3);
    // setSalleSelected([]);
    // setTitle('');
    setDebutDate('');
    setDebutTime('');
    setEndTime('');
  };

  const getSalle = () => {
    axios
        .get(
            DNS +
          '/salle/deleteGetPatchPlace/' +
          currentBuilding['currentbuildingRedux'].pk +
          '/',
            requestOptionsAxiosGet,
        )
        .then((response) => {
          // setSalle(response.data.fields);
          let tmp = [];
          response.data.fields.map((elem, key) => {
            tmp = tmp.concat({value: elem.pk, label: elem.name});
          });
          setSalleValue(tmp);
        });
  };

  const getReservations = (startDate, endDate) => {
    axios.get(
        DNS +
        '/salle/deleteGetPatchPlaceReservation/' +
        currentBuilding['currentbuildingRedux'].pk + '/',
        {
          params: {
            'start': startDate,
            'end': endDate,
          },
        },
        requestOptionsAxiosGet,
    ).then((response) => {
      if (response.data.fields) {
        setReservations({
          data: response.data.fields,
          error: false,
        });
        return;
      } else {
        setReservations({
          data: response.data.fields,
          error: false,
        });
        return;
      }
    });
  };

  let content = [];

  if (LReservations.error) {
    content = <p>ERROR: couldn't load reservation list properly.</p>;
  }

  if (LReservations.data) {
    content = LReservations.data
        .slice(0)
        .reverse()
        .filter((val) => {
          if (showSalleValueSelected.length != 0) {
            let tmp = false;
            showSalleValueSelected.map((e, key) => {
              if (val.place.name == e.label) {
                tmp = true;
              }
            });
            if (tmp == true) {
              if (searchTerm == '') {
                return val;
              } else if (
                val.place.name.toLowerCase().includes(searchTerm.toLowerCase())
              ) {
                return val;
              } else {
                return undefined;
              }
            }
            return undefined;
          }
          if (searchTerm == '') {
            return val;
          } else if (val.place.name.toLowerCase().includes(searchTerm.toLowerCase())) {
            return val;
          }
        })
        .map((reservation, key) => {
          const calendardata = {
            id: reservation.pk,
            title: reservation.place.name,
            start: reservation.debutDate + 'T' + reservation.debutTime,
            end: reservation.endDate + 'T' + reservation.endTime,
            color: 'red',
            extendedProps: {
              description: reservation.place.name,
              reservpk: reservation.pk,
              Etitle: reservation.place.name,
              EdebutDate: reservation.debutDate,
              EdebutTime: reservation.debutTime,
              EendTime: reservation.endTime,
              Ereserved: reservation.place,
              createdBy: reservation.createdBy,
            },
          };
          return calendardata;
        });
    // console.log(content)
  }

  const handleDateClick = (arg) => {
    // bind with an arrow function
    cleanDataReservation();
    setEventTitle(arg.event.title);
    setEventName(arg.event.extendedProps.description);
    // setTitle(arg.event.extendedProps.Etitle);
    setDebutDate(arg.event.extendedProps.EdebutDate);
    setDebutTime(arg.event.extendedProps.EdebutTime);
    setEndTime(arg.event.extendedProps.EendTime);
    setResPk(arg.event.extendedProps.reservpk);
    setShowModal2(true);
    setCreatedBy(arg.event.extendedProps.createdBy);
    // setReserved(arg.event.extendedProps.Ereserved);
    // setSalleSelected(arg.event.extendedProps.Ereserved[0].name);
  };

  // const fillDictWithValue = () => {
  //   return ({
  //     'showSalleSelected': showSalleSelected,
  //     'setSalleSelected': setSalleSelected,
  //     'showTitle': showTitle,
  //     'setTitle': setTitle,
  //     'showDebutDate': showDebutDate,
  //     'setDebutDate': setDebutDate,
  //     'showDebutTime': showDebutTime,
  //     'setDebutTime': setDebutTime,
  //     'showEndTime': showEndTime,
  //     'setEndTime': setEndTime,
  //     'showReserved': showReserved,
  //     'showSalle': showSalle,
  //     'showResPk': showResPk,
  //   });
  // };

  return (
    <>
      <Row>
        <Col md="12">
          <Card>
            <Card.Header>
              {!isMobile ?
                    <Card.Title as="h4">Mes Places</Card.Title> :
                    <Card.Title as="h4" className={'text-center'}>Mes Places</Card.Title>
              }

              <p className="card-category d-none d-sm-block">Liste des places de parking</p>
              <div className="row pl-0 pr-0" style={{paddingTop: '15px'}}>
                {user['user'].role != 'collab' ? (
                  <Button
                    id="Ajouter"
                    className={'col-sm-12 col-12 col-md-3 col-lg-3 mr-3'}
                    onClick={() => {
                      getSalle();
                      cleanDataReservation();
                      // setShowModal(true);
                    }}
                  >
                    Réserver une place de parking
                  </Button>) :
                  null }
                {/* <div style={{position: 'absolute'}}>*/}
                <Select
                  placeholder="Rechercher par place"
                  closeMenuOnSelect={false}
                  components={animatedComponents}
                  className="form-select col-sm-12 col-12 col-md-3 col-lg-3 pl-0 pr-0"
                  isMulti
                  options={showSalleValue}
                  onChange={(e) => setSalleValueSelected(e)}
                />
                {/* </div>*/}
                <div id="custom-search-input" className={'d-none d-sm-none d-md-block col-12 col-md-3 col-lg-3'}>
                  <div className="input-group ">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Rechercher"
                      onChange={(event) => {
                        setSearchTerm(event.target.value);
                      }}
                    />
                    <span className="input-group-btn btn btn-warning">
                      <span className=" fas fa-search"></span>
                    </span>
                  </div>
                </div>
              </div>
            </Card.Header>
            <Card.Body>
              <FullCalendar
                ref={calendarRef}
                plugins={isMobile ? [timeGridPlugin, dayGridPlugin] : [timeGridPlugin, dayGridPlugin]}
                slotEventOverlap={true}
                height={500}
                eventMaxStack={3}
                nowIndicator={true}
                allDaySlot={true}
                slotDuration={'00:30:00'}
                Duration={'00:00:00'}
                initialView={isMobile && !isTablet ? 'timeGridDay' : 'timeGridWeek'}
                buttonText={{
                  today: 'Aujourd\'hui',
                  month: 'Mois',
                  week: 'Semaine',
                  day: 'Jour',
                  list: 'Liste',
                }}

                customButtons={{
                  next: {
                    click: () => {
                      const calendarApi = calendarRef.current.getApi();
                      calendarApi.next();
                      const type = moment(calendarApi.getDate());
                      const date2 = moment(showEndWeekDate);
                      if (type > date2) {
                        const start = type.startOf('week').add(1, 'days').format('YYYY-MM-DD');
                        const end = type.endOf('week').add(1, 'days').format('YYYY-MM-DD');
                        setStartWeekDate(start);
                        setEndWeekDate(end);
                        getReservations(start, end);
                      }
                    },
                  },
                  prev: {
                    click: () => {
                      const calendarApi = calendarRef.current.getApi();
                      calendarApi.prev();
                      const type = moment(calendarApi.getDate());
                      const date2 = moment(showStartWeekDate);
                      if (type < date2) {
                        const start = type.startOf('week').add(1, 'days').format('YYYY-MM-DD');
                        const end = type.endOf('week').add(1, 'days').format('YYYY-MM-DD');
                        setStartWeekDate(start);
                        setEndWeekDate(end);
                        getReservations(start, end);
                      }
                    },
                  },
                }}
                headerToolbar={{
                  start: 'title',
                  center: '',
                  end: isMobile || isTablet ? 'today prev,next' : 'today timeGridWeek,timeGridDay prev,next',
                }}
                locale="fr"
                eventDisplay="list-item"
                firstDay={1}
                eventClick={handleDateClick}
                events={content}
                navLinks={true}
              />
              {/* ##################################### ADD MODAL BELOW #################################################### */}
              {/* <ModalADDReservation showModal={showModal} setShowModal={setShowModal} showTodayDate={showTodayDate} showMaxdayDate={showMaxdayDate} showSalle={showSalle} getReservations={getReservations} start={showStartWeekDate} end={showEndWeekDate} /> */}
              {/* ##################################### VIEW DELETE MODAL BELOW #################################################### */}
              <ModalVIEWDELETEReservation showModal={showModal2} setShowModal={setShowModal2} setShowModal3={setShowModal3} getReservations={getReservations} showResPk={showResPk} showEventTitle={showEventTitle} showEventName={showEventName} showDebutDate={showDebutDate} showDebutTime={showDebutTime} showEndTime={showEndTime} showCreatedBy={showCreatedBy} start={showStartWeekDate} end={showEndWeekDate} />
              {/* ##################################### EDIT MODAL BELOW #################################################### */}
              {/* <ModalEDITReservation showModalValue={showModal3} setShowModal={setShowModal3} showTodayDate={showTodayDate} showMaxdayDate={showMaxdayDate} getReservations={getReservations} fillDictWithValue={fillDictWithValue} start={showStartWeekDate} end={showEndWeekDate} /> */}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
}

export default Place;
